import { render } from "./index.vue?vue&type=template&id=80f05f90&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=80f05f90&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f05f90"]])

export default __exports__